export * from "./metadata.constants";
export * from "./account.constants";
export * from "./dataset.constants";
export * from "./flow.constants";
export * from "./app.constants";
export * from "./filepreview.constants";
export * from "./notices.constants";
export * from "./font.constants.js";

export const MODULE_MAPPING = {
  platform: "kfplatform",
  case: "kfcase",
  page: "kfpage",
  application: "kfapplication",
  process: "kfprocess",
  components: "kfcomponents",
  analytics: "kfanalytics",
  appstore: "kfappstore"
};

export const ENV = {
  PRD: "Prd",
  UAT: "Uat"
};

export const DEVICE = {
  WEB: "Web",
  PWA: "Pwa"
};

export const BROWSER_STORAGE_CONSTANTS = {
  IS_CHAT_PING_ENABLED: "isChatPingEnabled",
  X_USER_HEADER_LAST_SET_AT: "xUserHeaderLastSetAt"
};

export const DOCUMENT_VISIBILITY_STATES = {
  VISIBLE: "visible",
  HIDDEN: "hidden"
};

export const SERVICE_WORKER_LISTENER_TYPES = {
  PUSH_NOTIFICATION_CLICK: "PUSH_NOTIFICATION_CLICK",
  CHAT_SOUND: "CHAT_SOUND",
  CHAT_SYNC_INTERVAL: "CHAT_SYNC_INTERVAL",
  BASE_SIGNOUT: "BASE_SIGNOUT"
};

export const EXTENDED_MANAGEMENT_FEATURE_FLAGS = {
  ADMIN_ALLOW_EMPLOYEE_MANAGEMENT: "admin_allow_employee_management",
  ADMIN_ALLOW_MEMBER_MANAGEMENT: "admin_allow_member_management"
};

export const USER_PROFILE_TYPES = {
  EMPLOYEE: "employee",
  MEMBER: "member",
  USER: "user"
};
export const USER_EXTENSION_TYPES = {
  USER: "User",
  EMPLOYEE: "_employee",
  MEMBER: "_member"
};

export const EXTENDED_MANAGEMENT_MODEL_IDS = {
  [EXTENDED_MANAGEMENT_FEATURE_FLAGS.ADMIN_ALLOW_EMPLOYEE_MANAGEMENT]:
    USER_PROFILE_TYPES.EMPLOYEE,
  [EXTENDED_MANAGEMENT_FEATURE_FLAGS.ADMIN_ALLOW_MEMBER_MANAGEMENT]:
    USER_PROFILE_TYPES.MEMBER
};

export const WORK_PLATFORM_FEATURE_FLAGS = {
  ALLOW_WORK_PLATFORM_NAVIGATION: "allow_work_platform_navigation",
  FLOW_ALLOW_SECURITY_SETTING: "flow_allow_security_setting",
  APP_ALLOW_APP_MODULE: "app_allow_app_module",
  APP_ALLOW_APP_BUILDER: "app_allow_app_builder",
  APP_ALLOW_CODE: "app_allow_code",
  ADMIN_ALLOW_SANDBOX: "admin_allow_sandbox",
  ADMIN_ALLOW_SANDBOX_PROD: "admin_allow_sandbox_prod",
  ADMIN_ALLOW_SANDBOX_DEV: "admin_allow_sandbox_dev",
  ADMIN_ALLOW_SANDBOX_TEST: "admin_allow_sandbox_test",
  APP_ALLOW_APP_STORE: "app_allow_app_store",
  APP_STORE_ALLOW_FREE_APP: "app_store_allow_free_app",
  APP_STORE_ALLOW_PAID_APP: "app_store_allow_paid_app",
  APP_STORE_ALLOW_PROVISIONABLE_APP: "app_store_allow_provisionable_app",
  APP_STORE_ALLOW_UNLOCKED_APP: "app_store_allow_unlocked_app",
  FORM_ALLOW_FORM_MODULE: "form_allow_form_module",
  ALLOW_PROJECT_CREATION: "project_allow_project_creation",
  APP_ALLOW_APP_CODE: "app_allow_app_code",
  ADMIN_ALLOW_CUSTOM_PORTAL: "admin_allow_custom_portal",
  ADMIN_ALLOW_SERVICE_ACCOUNT_IMPERSONATION:
    "admin_allow_serviceaccount_impersonation",
  ADMIN_ALLOW_SERVICE_ACCOUNT: "admin_allow_admin_serviceaccount",
  ACCOUNT_ALLOW_ADMIN_GOVERNANCE: "account_allow_admin_governance",
  ADMIN_ALLOW_ACCOUNT_GOVERNANCE: "admin_allow_account_governance"
};

export const CHART_TYPES = {
  PIE: "pie",
  BAR: "bar",
  LINE: "line",
  AREA: "area",
  COMBO: "combo",
  SCATTER: "scatter",
  DOUGHNUT: "doughnut"
};

export const CHART_AXIS = {
  X_AXIS: "x",
  Y_AXIS: "y"
};

export const THEME = {
  LIGHT: "light",
  DARK: "dark",
  DIM: "dim"
};
export const SIGNATURE_PEN_COLOR = {
  DEFAULT: "#263045",
  LIGHT: "#263045" // subject to change in future
};
export const LEFTNAV_ACTION = {
  ACTIVATE: "Activate",
  ADD: "Add",
  UPDATE: "Update",
  DELETE: "delete"
};

export const ANALYTICS_FEATURE_FLAGS = {
  REPORT_VIEW_TABLE: "report_view_table",
  REPORT_VIEW_CHART: "report_view_chart",
  REPORT_VIEW_PIVOT: "report_view_pivot",
  REPORT_VIEW_DATAVIEW: "report_view_dataview",
  REPORT_CREATE_TABLE: "report_create_table",
  REPORT_CREATE_CHART: "report_create_chart",
  REPORT_CREATE_PIVOT: "report_create_pivot",
  REPORT_CREATE_DATAVIEW: "report_create_dataview"
};

export const CLOUD_PROVIDER = {
  GCP: "GCP",
  AWS: "AWS"
};

export const SDK_KIND = {
  LOWCODE: "lowcode",
  NOCODE: "nocode"
};

// Filepicker Default Configuration

export const FILE_PICKER_CONFIG = {
  minCount: 0,
  maxCount: 10,
  minSize: 0,
  compression: false,
  maxSize: 104857600,
  fileExtensions: ["*"],
  imageProps: {
    crop: false,
    sizes: [
      [60, 60],
      [900, 400]
    ]
  },
  attachmentConfigProps: {
    sizes: [
      [1200, 800],
      [100, 100]
    ],
    crop: false
  },
  imageConfigProps: {
    sizes: [
      [1200, 800],
      [300, 300]
    ],
    crop: true
  },
  imageExtensions: ["JPG", "JPEG", "BMP", "PNG", "TIF"],
  validSelectedFile: [],
  autoUpload: true
};
